import React, { useState } from "react";
import {
    Box,
    Typography,
    TextField,
    Slider,
    Grid,
    Paper,
    List,
    ListItem,
    ListItemText,
    Divider,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Footer from "./Footer";

import useSipCalculator from "./calculators/useSipCalculator";
import useLumpsumCalculator from "./calculators/useLumpsumCalculator";
import useSwpCalculator from "./calculators/useSwpCalculator";
// import useMutualFundCalculator from "./calculators/useMutualFundCalculator";
import usePpfCalculator from "./calculators/usePpfCalculator";
import useFdCalculator from "./calculators/useFdCalculator";
import useRdCalculator from "./calculators/useRdCalculator";
import useEmiCalculator from "./calculators/useEmiCalculator";
import { fontSize } from "@mui/system";

const MainCalculator = () => {
    const theme = useTheme();
    const [selected, setSelected] = useState("sip");

    const sipData = useSipCalculator();
    const lumpsumData = useLumpsumCalculator();
    const swpData = useSwpCalculator();
    // const mutualFundData = useMutualFundCalculator();
    const ppfData = usePpfCalculator();
    const fdData = useFdCalculator();
    const rdData = useRdCalculator();
    const emiData = useEmiCalculator();

    const calculators = {
        sip: sipData,
        lumpsum: lumpsumData,
        swp: swpData,
        // mutual: mutualFundData,
        ppf: ppfData,
        fd: fdData,
        rd: rdData,
        emi: emiData,


    };

    const current = calculators[selected];

    const investedPercent =
        current.totalValue > 0
            ? (current.investedAmount / current.totalValue) * 100
            : 0;

    return (
        <Box sx={{ py: 6, mt: 4 }}>
            <Box sx={{ maxWidth: "1200px", mx: "auto", px: 4 }}>

                <Box
                    sx={{
                        pt: { xs: 0, md: 3 },
                        pb: { xs: 3, md: 4 },
                        textAlign: "center",
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: { xs: "20px", sm: "28px", md: "40px" },
                            fontWeight: 600,
                            lineHeight: 1.1,
                            color: theme.palette.text.primary,
                            position: "relative",
                            display: "inline-block",
                            width: "100%",
                        }}
                    >
                        Smart{" "}
                        <Box
                            component="span"
                            sx={{
                                fontWeight: 900,
                                background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.text.primary})`,
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                                position: "relative",
                                display: "inline-block",
                                "&::after": {
                                    content: '""',
                                    position: "absolute",
                                    bottom: "-4px",
                                    left: 0,
                                    width: "100%",
                                    height: "2px",
                                    background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, transparent 100%)`,
                                },
                            }}
                        >
                            Financial
                        </Box>{" "}
                        Calculators
                    </Typography>
                </Box>

                <Grid container spacing={4}>




                    {/* LEFT SIDE INPUT */}
                    <Grid item xs={12} md={8}>
                        <Paper sx={{ p: 4, borderRadius: 3 }}>
                            <Grid container spacing={4}>

                                {/* INPUTS */}
                                <Grid item xs={12} md={6}>
                                    <Typography variant="h6" mb={3} fontWeight={600} fontSize={{ xs: "16px", sm: "18px", md: "20px" }}
                                    >
                                        {current.title}
                                    </Typography>

                                    {current.inputs.map((input, i) => (
                                        <Box key={i} mb={3}>
                                            <Typography
                                                sx={{
                                                    // fontSize: "16px",
                                                    fontSize: { xs: "12px", sm: "14px", md: "16px" },
                                                    // color: "red"
                                                }}


                                            >{input.label}</Typography>
                                            <TextField
                                                fullWidth
                                                type="number"
                                                value={input.value}
                                                disabled={input.disabled || false}
                                                onChange={(e) =>
                                                    input.setter && input.setter(Number(e.target.value))
                                                }
                                            />
                                            {!input.disabled && (
                                                <Slider
                                                    value={input.value}
                                                    min={input.min}
                                                    max={input.max}
                                                    step={input.step}
                                                    onChange={(_, val) => input.setter(val)}
                                                    sx={{ mt: 2 }}
                                                />
                                            )}
                                        </Box>
                                    ))}
                                </Grid>

                                {/* RESULTS + DONUT */}
                                <Grid item xs={12} md={6}>
                                    <Box display="flex" flexDirection="column" alignItems="center">

                                        {/* DONUT */}
                                        <Box
                                            sx={{
                                                width: 200,
                                                height: 200,
                                                borderRadius: "50%",
                                                background: `conic-gradient(${theme.palette.primary.main} 0% ${investedPercent}%, #00a8a8 ${investedPercent}% 100%)`,
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    width: 120,
                                                    height: 120,
                                                    borderRadius: "50%",
                                                    background: "#fff",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    flexDirection: "column",
                                                }}
                                            >
                                                <Typography fontSize={14}>
                                                    Total Value
                                                </Typography>
                                                <Typography fontWeight={700}>
                                                    ₹{Math.round(current.totalValue).toLocaleString("en-IN")}
                                                </Typography>
                                            </Box>
                                        </Box>



                                        <Box mt={3} textAlign="center" sx={{
                                            "& .MuiTypography-root": {
                                                fontSize: { xs: "12px", sm: "14px", md: "16px" }
                                            },
                                            // color: "red"
                                        }}>

                                            {selected === "emi" ? (

                                                <>
                                                    <Typography>Monthly EMI</Typography>
                                                    <Typography fontWeight={600}>
                                                        ₹{Math.round(current.monthlyEmi).toLocaleString("en-IN")}
                                                    </Typography>

                                                    <Typography mt={2}>Principal Amount</Typography>
                                                    <Typography fontWeight={600}>
                                                        ₹{current.principalAmount.toLocaleString("en-IN")}
                                                    </Typography>

                                                    <Typography mt={2}>Total Interest</Typography>
                                                    <Typography fontWeight={600} color="error.main">
                                                        ₹{Math.round(current.totalInterest).toLocaleString("en-IN")}
                                                    </Typography>

                                                    <Typography mt={2}>Total Amount</Typography>
                                                    <Typography fontWeight={600} color="success.main">
                                                        ₹{Math.round(current.totalAmount).toLocaleString("en-IN")}
                                                    </Typography>
                                                </>

                                            ) : selected === "ppf" ? (

                                                <>
                                                    <Typography>Invested Amount</Typography>
                                                    <Typography fontWeight={600}>
                                                        ₹{current.investedAmount.toLocaleString("en-IN")}
                                                    </Typography>

                                                    <Typography mt={2}>Total Interest</Typography>
                                                    <Typography fontWeight={600} color="success.main">
                                                        ₹{Math.round(current.estimatedReturns).toLocaleString("en-IN")}
                                                    </Typography>

                                                    <Typography mt={2}>Maturity Value</Typography>
                                                    <Typography fontWeight={600}>
                                                        ₹{Math.round(current.totalValue).toLocaleString("en-IN")}
                                                    </Typography>
                                                </>

                                            ) :
                                                selected === "swp" ? (

                                                    <>
                                                        <Typography>Total Investment</Typography>
                                                        <Typography fontWeight={600}>
                                                            ₹{current.totalInvestment.toLocaleString("en-IN")}
                                                        </Typography>

                                                        <Typography mt={2}>Total Withdrawal</Typography>
                                                        <Typography fontWeight={600} color="error.main">
                                                            ₹{Math.round(current.totalWithdrawal).toLocaleString("en-IN")}
                                                        </Typography>

                                                        <Typography mt={2}>Final Value</Typography>
                                                        <Typography fontWeight={600} color="success.main">
                                                            ₹{Math.round(current.finalValue).toLocaleString("en-IN")}
                                                        </Typography>
                                                    </>

                                                ) :

                                                    (

                                                        <>
                                                            <Typography>Invested Amount</Typography>
                                                            <Typography fontWeight={600}>
                                                                ₹{current.investedAmount.toLocaleString("en-IN")}
                                                            </Typography>

                                                            <Typography mt={2}>Estimated Returns</Typography>
                                                            <Typography fontWeight={600} color="success.main">
                                                                ₹{Math.round(current.estimatedReturns).toLocaleString("en-IN")}
                                                            </Typography>

                                                            <Typography mt={2}>Total Value</Typography>
                                                            <Typography fontWeight={600}>
                                                                ₹{Math.round(current.totalValue).toLocaleString("en-IN")}
                                                            </Typography>
                                                        </>

                                                    )}

                                        </Box>

                                    </Box>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>

                    {/* RIGHT SIDE LIST */}
                    <Grid item xs={12} md={4}>
                        <Paper
                            sx={{
                                borderRadius: 3,
                                height: "100%",
                                display: "flex",
                                flexDirection: "column"
                            }}
                            elevation={1}
                        >
                            <Typography
                                sx={{
                                    p: 3,
                                    fontWeight: 700,
                                    // color: "Red"



                                }}
                            >
                                Popular Calculators
                            </Typography>

                            <Divider />

                            <List sx={{ flexGrow: 1 }
                            }>
                                {Object.keys(calculators).map((key, index) => (
                                    <React.Fragment key={key}>
                                        <ListItem
                                            button
                                            selected={selected === key}
                                            onClick={() => setSelected(key)}
                                            sx={{
                                                transition: "0.3s",
                                                "&.Mui-selected": {
                                                    backgroundColor: "#00a8a8"
                                                },
                                                "&.Mui-selected:hover": {
                                                    backgroundColor: "#00a8a8"
                                                },
                                                "&:hover": {
                                                    backgroundColor: "#00a8a8"
                                                }
                                            }}
                                        >
                                            <ListItemText
                                                primary={calculators[key].title}
                                                primaryTypographyProps={{
                                                    fontSize: { xs: 12, sm: 14, md: 16 },
                                                    fontWeight: selected === key ? 600 : 400,
                                                    color:
                                                        selected === key
                                                            ? theme.palette.primary.main
                                                            : theme.palette.text.primary
                                                }}
                                            />
                                        </ListItem>

                                        {index !== Object.keys(calculators).length - 1 && <Divider />}
                                    </React.Fragment>
                                ))}
                            </List>
                        </Paper>
                    </Grid>
                </Grid>

                {/* INFO BOX */}
                <Paper sx={{
                    p: { xs: 3, md: 5 }, mt: 3, borderRadius: 3, mb: 2
                }} elevation={1}>

                    <Typography
                        sx={{ fontSize: { xs: 16, sm: 18, md: 20 }, fontWeight: 700, }}
                        gutterBottom
                    >
                        {current.infoContent.heading}
                    </Typography>

                    <Typography
                        sx={{ fontSize: { xs: 12, sm: 14, md: 16 } }}
                        color="text.secondary"
                        paragraph
                    >
                        {current.infoContent.description}
                    </Typography>

                    <Typography
                        sx={{ fontSize: { xs: 16, sm: 18, md: 20 }, fontWeight: 600 }}
                        gutterBottom
                    >
                        {current.infoContent.subHeading1}
                    </Typography>

                    <Typography
                        sx={{ fontSize: { xs: 12, sm: 14, md: 16 } }}
                        color="text.secondary"
                        paragraph
                    >
                        {current.infoContent.subContent1}
                    </Typography>

                    <Typography
                        sx={{ fontSize: { xs: 16, sm: 18, md: 20 }, fontWeight: 600 }}
                        gutterBottom
                    >
                        {current.infoContent.subHeading2}
                    </Typography>

                    <Typography
                        sx={{ fontSize: { xs: 12, sm: 14, md: 16 } }}
                        color="text.secondary"
                        paragraph
                    >
                        {current.infoContent.subContent2}
                    </Typography>

                    <Box sx={{ background: "#f5f5f5", p: 2, borderRadius: 2, mb: 2 }}>
                        <Typography
                            sx={{ fontSize: { xs: 12, sm: 14, md: 16 }, fontWeight: 600 }}
                        >
                            {current.infoContent.formula}
                        </Typography>
                    </Box>

                    <Typography
                        sx={{ fontSize: { xs: 16, sm: 18, md: 20 }, fontWeight: 600 }}
                        gutterBottom
                    >
                        {current.infoContent.subHeading3}
                    </Typography>

                    <Box
                        component="ul"
                        sx={{
                            pl: 3,
                            fontSize: { xs: 12, sm: 14, md: 16 },
                            color: "text.secondary"
                        }}
                    >
                        {current.infoContent.benefits.map((item, index) => (
                            <li key={index}>{item}</li>
                        ))}
                    </Box>

                </Paper>
            </Box>

            <Footer />
        </Box>
    );
};

export default MainCalculator;